// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
import $ from 'jquery'
window.jQuery = $
window.$ = $

require("@rails/ujs").start()
require("turbolinks").start()
require("channels")

require.context('../images', true)

import 'bootstrap'

require('../scss/application.scss')

import '../controllers'
import 'admin-lte/dist/js/adminlte.min'
import 'overlayscrollbars/js/jquery.overlayScrollbars.js'
import 'overlayscrollbars/css/OverlayScrollbars.css'

import '../extends/date.js'

import '../extends/date.js'
import '../extends/select2.js'
import '../extends/turbolinks.js'

document.addEventListener('turbolinks:before-cache', () => {
  $("#toastsContainerBottomLeft").remove()
  $("#toastr-alerts").remove()

  document.querySelectorAll('.modal').forEach((el) => {
    if ($(el).is(':visible')) { $(el).modal('toggle') }
    $(el).hide()
    $('.modal-backdrop').remove()
  })
})

document.addEventListener('turbolinks:load', () => {
  document.querySelectorAll('.custom-switch').forEach((el) => {
    el.innerHTML = el.innerHTML
  })
  
  // https://github.com/select2/select2/issues/5993
  $(document).on('select2:open', () => {
    let allFound = document.querySelectorAll('.select2-container--open .select2-search__field')
    allFound[allFound.length - 1].focus()
  })
  
  $(".main-sidebar").overlayScrollbars({ });

});